import utils from './utils';

import auth from './auth';
import campaigns from './campaigns';
import products from './products';
import sales from './sales';

const index = {
  utils,

  auth,
  campaigns,
  products,
  sales,
};

export default index;